import { ElementRef, Input, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
@Component({
  selector: 'app-profile',
  templateUrl: './profile-uploader.component.html',
  styleUrls: ['./profile-uploader.component.scss']
})
export class ProfileUploaderComponent implements OnInit {
  /* --------------------------------- Fields --------------------------------- */
  static nextId: number = 0;
  // nextUniqueId = `profile-image-${ProfileComponent.nextId}`;
  mimeArray: string[] =
    ['image/jpg',
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/vnd.microsoft.icon',
      'image/svg+xml',
      'image/tiff',
      'image/webp'];
  @Input() fileInput: FormControl;
  @Input() size: number;
  @Input() isDimensionCheck: boolean;
  @Input() width: number;
  @Input() height: number;
  isHovering: boolean;
  progress = 0;
  @ViewChild('fileVariable') fileInputRef: ElementRef;
  constructor(
    // private mediaService: MediaService,
    // private toast: ToastService,
    // private log: LogService,
    private elRef: ElementRef
  ) {
  }
  /* ---------------------------- Life Cycle Hooks ---------------------------- */
  ngOnInit() {
  }
  /* ---------------------------- Custom Functions ---------------------------- */
  // setImage(files: FileList) {
  //   this.fileInput.markAsTouched();
  //   const file: File = files.item(0);
  //   // Mime Checking
  //   if (!this.mimeArray.includes(file.type)) {
  //     this.toast.openSnackBar('Upload Please upload a valid image');
  //     return;
  //   }
  //   // Size Checking
  //   if (file.size >= this.size * 1024 * 1024) {
  //     this.toast.openSnackBar(`The Image is Above ${this.size} MB`);
  //     return;
  //   }
  //   // Dimension Checking
  //   if (this.isDimensionCheck) {
  //     const img = new Image();
  //     img.src = URL.createObjectURL(file);
  //     img.onload = (e: any) => {
  //       const height = e.path[0].height;
  //       const width = e.path[0].width;
  //       console.log(height, width);
  //       this.fileUploader(file);
  //     }
  //   } else {
  //     this.fileUploader(file);
  //   }
  // }
  // fileUploader(file: File) {
  //   const formData = new FormData();
  //   formData.append('directory', 'profileImages');
  //   formData.append('file', file);
  //   formData.append('Content-Type', 'application/json');
  //   formData.append('accept', 'application/json');
  //   this.mediaService.uploadMedia(formData).subscribe(response => {
  //     if (response.message) {
  //       this.log.log(response.message);
  //       this.progress = response.message;
  //     }
  //     if (response.signedUrl) {
  //       this.log.log(response.signedUrl);
  //       this.fileInput.setValue(response.signedUrl);
  //       this.fileInput.updateValueAndValidity();
  //       this.progress = 0;
  //       this.elRef.nativeElement.getElementsByClassName(this.nextUniqueId)[0].value = null;
  //     }
  //   });
  // }
  /* ------------------------------ Remove Image ------------------------------ */
  removeValue() {
    this.fileInput.setValue(null);
  }
  /* ------------------------------ Toggle Hover ------------------------------ */
  toggleHover(event: boolean) {
    this.isHovering = event;
  }
}
